import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { FileItem } from "../../../../models/entities/file-item";
import { ArchivosWebService } from "../../../../services/archivos-web.service";
import { ArchivoPDF } from "../../../../models/entities/archivoPdf";
import { AlertasService } from "src/app/services/alertas.service";
import { Alert } from "../../../../models/alert";
import { first } from "rxjs/operators";

@Component({
  selector: "carga-ficha",
  templateUrl: "./carga-ficha.component.html",
  styleUrls: ["./carga-ficha.component.scss"],
})
export class CargaFichaComponent implements OnInit {
  @Input("datosObra")
  public datosObra: LevantamientoSeleccionadoDTO;
  public archivos: any[] = [];
  public archivos2: FileItem[] = [];
  public archivosPdf: ArchivoPDF[] = [];
  public tipoError: boolean = false;
  public completado: boolean;
  public alerta: Alert = new Alert();
  public value: any[] = [];
  mensaje: string;
  public tipoError2: boolean = false;

  constructor(
    public cargaDeArchivo: ArchivosWebService,
    public alertasService: AlertasService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.llamarPdfs(changes.datosObra.currentValue);
  }

  public eliminarArchivo(indice: number): void {
    this.alerta.confirmacion().then((result) => {
      if (result.value === true) {
        this.archivos.splice(indice, 1);
        this.archivos2.splice(indice, 1);
      }
    });
  }

  public cargarArchivos(archivos: FileList): void {
    this.archivos[0] = archivos[0];
    const file: FileItem = new FileItem(this.archivos[0]);

    if (file.archivo.type === "application/pdf") {
      this.archivos2 = [];
      this.archivos2.push(file);
      this.tipoError = false;
    } else {
      this.archivos2 = [];
      this.tipoError = true;
    }
    this.completado = null;
  }

  cargarFicha(key: string) {
    // this.cargaDeArchivo.cargarArchivoFirebase(this.archivos2, key);
    // this.llamarPdfs2(key, null);

    this.cargaDeArchivo
      .validarNombreArchivo(this.archivos2[0].nombreArchivo, key)
      .pipe(first())
      .subscribe((data) => {
        this.value = data;
        // console.log(this.value);

        if (this.value.length > 0) {
          const validar = this.value.find(
            (element) => element.keyLevantamientoObra === key
          );

          if (validar === undefined) {
            this.subirFichaFirebase(key);
          } else {
            this.mensaje =
              "No se puede registrar un archivo con el mismo nombre y fecha de una misma obra.";
            this.alerta.errorCustom(this.mensaje);
          }
        } else {
          this.subirFichaFirebase(key);
        }
      });
  }

  subirFichaFirebase(key: string) {
    this.cargaDeArchivo.cargarArchivoFirebase(this.archivos2, key);
    this.llamarPdfs2(key, null);
  }

  public limpiarArchivos(): void {
    this.archivos = [];
    this.archivos2 = [];
    this.completado = null;
  }

  public llamarPdfs(datosObra: LevantamientoSeleccionadoDTO) {
    this.completado = null;

    this.cargaDeArchivo.getPdf(datosObra.levObra.key).subscribe((data) => {
      this.archivosPdf = data;
      // console.log(this.archivosPdf);
    });
  }

  public llamarPdfs2(key: string, completado?: boolean) {
    if (completado === true) {
      this.completado = true;
    } else {
      this.completado = null;
    }
    this.cargaDeArchivo.getPdf(key).subscribe((data) => {
      this.archivosPdf = data;
      // console.log(this.archivosPdf);
    });
  }

  deleteFile(file: ArchivoPDF, key: string) {
    this.alerta.confirmacion().then((result) => {
      if (result.value === true) {
        this.cargaDeArchivo
          .deleteFileDatabase(file.key)
          .then(() => {
            this.cargaDeArchivo.deleteFileStorage(file.nombre, key);
            this.alertasService.mostrarAlerta(
              "success",
              "Archivo eliminado correctamente!"
            );
            this.completado = true;
          })
          .catch((error) => {
            console.log(error);
            this.alertasService.mostrarAlerta(
              "error",
              "Error al eliminar el archivo!"
            );
            this.completado = false;
          });
        this.llamarPdfs2(key, true);
      }
    });
  }
}
